import React from 'react';
import { TauriPlayer } from '@readcloud/fetch-wrapper';
import {
  YouTubeProxyEmbed,
  extractYouTubeId,
} from '@readcloud/annotations';
import { DocumentWithExtrasContext } from '../../context/DocumentWithExtras';

import ModalManager from '../Modals/ModalManager';

import { jobsActions, useAppDispatch } from '@readcloud/state';
import { v4 as uuidV4 } from 'uuid';

type Props = {
  onGoBack: () => void;
};

export const MediaViewer = (props: Props) => {
  const { data } = React.useContext(DocumentWithExtrasContext);

  const dispatch = useAppDispatch();

  const youtubeId = extractYouTubeId(
    typeof data === 'string' ? data : undefined
  );

  return (
    <>
      <div className="rc-flex rc-flex-1 rc-w-full rc-h-full rc-items-center rc-justify-center">
        <div className="rc-flex rc-max-h-screen rc-max-w-full">
          {youtubeId ? (
            <YouTubeProxyEmbed
              videoId={youtubeId}
              className="rc-flex rc-cursor-auto"
            />
          ) : (
            <TauriPlayer
              className="rc-flex rc-cursor-auto"
              url={data as string}
              controls
              onError={() =>
                dispatch(
                  jobsActions.addJob({
                    id: uuidV4(),
                    description: `An error occured loading this content.`,
                  })
                )
              }
              pip={false}
              config={{
                file: {
                  attributes: {
                    controlsList: 'nodownload',
                    disablePictureInPicture: true,
                  },
                },
              }}
            />
          )}
        </div>
      </div>
      <ModalManager />
    </>
  );
};
